<template>
  <ui-collapse
    class="destinations-collapse"
    :collapse-id="`collapse-low-results-all-countries`"
  >
    <template #ui-collapse-title>
      <translate tag="div">
        Start again by picking one of these wonderful destinations
      </translate>
    </template>
    <template #ui-collapse-body>
      <div>
        <div class="countries-list" :class="{ ready: isMounted }">
          <template v-for="country in countryList" :key="country.path">
            <pu-low-results-search-link
              v-if="!!counts[country.path]"
              :modify-filters="{ dates: {}, priceRange: {}, categoryIds: [] }"
              exclude-type="all"
              :hierarchy-path="country.path"
            >
              {{ country.name }}
              <span class="count">({{ counts[country.path] }})</span>
            </pu-low-results-search-link>
          </template>
        </div>
      </div>
    </template>
  </ui-collapse>
</template>

<script lang="ts">
import { getHierarchyRepository } from '~/apps/hierarchies/inversify.config'
import { getSearchCountService } from '~/apps/search/infrastructure/SearchCountsService'
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import type { Hierarchy } from '../../../hierarchies/domain/types'

@Component
class LowResultsAllCountries extends Vue {
  isMounted = false
  counts: Record<string, number> = {}

  countryList: Hierarchy[] = []
  async setCountryList() {
    try {
      this.countryList = await getHierarchyRepository().getCountries(
        this.$route.params.lang || 'en-gb',
      )
    } catch (error) {
      this.$sentry.captureException(error)
    }
  }

  async mounted() {
    await Promise.all([this.setCountryList(), this.updateFacetCounts()])
    this.isMounted = true
    await this.setCountryList()
  }

  isNotLast(index: number) {
    return index !== this.countryList.length - 1
  }

  private async updateFacetCounts() {
    const results = await getSearchCountService().fetchNonPriceSearchCounts(
      this.$route.params.lang || 'en-gb',
    )
    this.counts = results?.hierarchyCounts || {}
  }
}

export default toNative(LowResultsAllCountries)
</script>
<style scoped>
.count {
  font-size: var(--body);
  color: #826f35;
  align-self: center;
  margin-left: 0.25em;
}

.countries-list {
  padding: 1em 0;
  display: none;
}

.countries-list.ready {
  display: inherit;
}

.countries-list a {
  display: inline-flex;
  align-content: center;
  flex-direction: row;
  margin: 0 0.35em 0.5em 0;
  font-size: var(--small);
}

.destinations-collapse {
  border-bottom-color: #e6d8a9;
  border-top: 1px solid #e6d8a9;
  margin-top: 1em;
}

.destinations-collapse :deep(.ui-collapse-title) {
  font-weight: normal;
}

.destinations-collapse :deep(.ui-collapse-header) {
  padding: 0.5em 0;
  min-height: 3.5em;
}
</style>
